import { BehaviorSubject, Observable } from 'rxjs'
import { Inject, Injectable } from '@tanbo/vue-di-plugin'
import {
  BaselineItemTreeOperationService
} from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/baseline-item-tree-operation.service'
import {
  RepairTreeItem,
  SystemCategoryName, SystemType,
  SystemTypeInjectionToken
} from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'
import {
  applyBaselineRepairDisplayNamesToTree,
  DUBA_BASELINE_REPAIR_ITEMS_KEY
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'

@Injectable()
export class SystemWrapperService extends BaselineItemTreeOperationService {
  autoIDs: Observable<string[]>
  notifyIDs: Observable<string[]>
  ignoreIDs: Observable<string[]>
  baseLineItem: RepairTreeItem[]
  private updateAutoIDsEvent = new BehaviorSubject<string[]>([])
  private updateNotifyIDsEvent = new BehaviorSubject<string[]>([])
  private updateIgnoreIDsEvent = new BehaviorSubject<string[]>([])
  constructor (@Inject(SystemTypeInjectionToken) private systemType: SystemType) {
    super()
    const raw = localStorage.getItem(DUBA_BASELINE_REPAIR_ITEMS_KEY)
    const branch = raw ? JSON.parse(raw)[SystemCategoryName[this.systemType]] : []
    this.baseLineItem = applyBaselineRepairDisplayNamesToTree(branch)
    this.autoIDs = this.updateAutoIDsEvent.asObservable()
    this.notifyIDs = this.updateNotifyIDsEvent.asObservable()
    this.ignoreIDs = this.updateIgnoreIDsEvent.asObservable()
  }

  updateAutoIDs (ids: string[]) {
    this.updateAutoIDsEvent.next(ids)
  }

  updateIgnoreIDs (ids: string[]) {
    this.updateIgnoreIDsEvent.next(ids)
  }

  updateNotifyIDs (ids: string[]) {
    this.updateNotifyIDsEvent.next(ids)
  }

  getTerminalAutoItemIds (sids: string[]): string[] {
    const autoIDs = sids.filter(id => super.getAutoItemsId(this.baseLineItem).includes(id))
    this.updateAutoIDs(autoIDs)
    return autoIDs
  }

  getTerminalNotifyItemIds (sids: string[]): string[] {
    const notifyIDs = sids.filter(id => super.getNotifyItemsId(this.baseLineItem).includes(id))
    this.updateNotifyIDs(notifyIDs)
    return notifyIDs
  }

  getTerminalIgnoreItemIds (sids: string[]): string[] {
    const ignoreIDs = sids.filter(id => super.getIgnoreItemsId(this.baseLineItem).includes(id))
    this.updateIgnoreIDs(ignoreIDs)
    return ignoreIDs
  }
}
